<template>
    <section>
      <!--工具条-->
      <div>
        <el-form :inline="true">
          <el-form-item>
            <el-input
              v-model="filters.stationLineName"
              placeholder="生产线"
              @change="getReportList"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="filters.matName"
              placeholder="物资名称"
              @change="getReportList"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              type="datetime"
              placeholder="开始日期"
              v-model="filters.startTime"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
            <el-date-picker
              type="datetime"
              placeholder="结束日期"
              v-model="filters.endTime"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getReportList">查询</el-button>
            <el-button type="primary" @click="handlePrints('print')">
              打印
            </el-button>
            <el-button type="primary" @click="downReport">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!--列表-->
      <el-table
        :data="dmList"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%"
        id="print"
        border
        show-summary
        :summary-method="getSummaries"
      >

        <el-table-column prop="StationLineName" label="生产线"></el-table-column>
        <el-table-column prop="MatName" label="物资名称"></el-table-column>
        <el-table-column prop="PlcDatetime" label="时间"></el-table-column>
        <el-table-column prop="Quantity" label="用量"></el-table-column>
        <el-table-column prop="OpName" label="操作员"></el-table-column>
      </el-table>
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :page-size="filters.intPageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        class="my-pagination"
      ></el-pagination>
    </section>
  </template>
  
  <script>
  //引入Material.js的所有export的对象,并起别名为api,通过api.***访问成员
  import * as api from "../../api/command";
  import { BaseApiUrl, CmpanyName } from "../../api/api";
  import { getButtonList } from "../../promissionRouter";
  import Toolbar from "../../components/Toolbar";
  import Axios from "axios";
  import printJS from "print-js";
  import util from "../../../util/date";
  export default {
    components: { Toolbar },
    data() {
      return {
        currentRow: null,
        filters: {

          projectName: "",
          clientName: "",
          stationLineName: "",
          startTime: "",
          endTime: "",
          page: 1,
          intPageSize: 20,
        },
        total: 0,
        dmList: [],
        sumData: {},
        listLoading: false,
      };
    },
    computed: {},
    methods: {
      getSummaries(param) {
        var sums = [];
        sums[0] = "合计";
        sums[1] = "";
        sums[2] = "";
        sums[3] = this.sumData.Quantity;
        sums[4] =  "";
        return sums;
      },
      //工具条绑定事件方法
      callFunction(item) {
        this.filters = {
          name: item.search,
        };
        this[item.Func].apply(this, item);
      },
      //翻页事件绑定方法
      handleCurrentChange(val) {
        this.filters.page = val;
        this.getReportList();
      },
      //切换分页大小绑定方法
      handleSizeChange(size) {
        this.filters.intPageSize = size;
        this.getReportList(1);
      },
      //获取原材料消耗
      getReportList(optype) {
        if (optype == 1) {
          this.filters.page = 1;
        }
        let para = this.filters;
        this.listLoading = true;
        this.dmList = [];
        api
          .GetProdManDataSummary(para)
          .then((res) => {
            if (res && res.data && res.data.response && res.data.response.data)
              this.dmList = res.data.response.data;
            this.total = res.data.response.dataCount;
            this.sumData = res.data.responsesum;
          })
          .finally(() => {
            this.listLoading = false;
          });
      },
      //导出原材料消耗
      downReport() {
        let para = this.filters;
        var sheetName = "手动耗料统计";
        api.DownProdManDataSummary(para, sheetName).then((res) => {});
      },
      /** 打印按钮操作 */
      handlePrints(id) {
        const html = document.querySelector("#" + id).innerHTML;
        // 新建一个 DOM
        const div = document.createElement("div");
        const printDOMID = "printDOMElement";
        div.id = printDOMID;
        div.innerHTML = html;
  
        // 提取第一个表格的内容 即表头
        const ths = div.querySelectorAll(".el-table__header-wrapper th");
        const ThsTextArry = [];
        for (let i = 0, len = ths.length; i < len; i++) {
          if (ths[i].innerText !== "") ThsTextArry.push(ths[i].innerText);
        }
  
        // 删除多余的表头
        div.querySelector(".hidden-columns").remove();
        // 第一个表格的内容提取出来后已经没用了 删掉
        div.querySelector(".el-table__header-wrapper").remove();
  
        // 将第一个表格的内容插入到第二个表格
        let newHTML = "<tr>";
        for (let i = 0, len = ThsTextArry.length; i < len; i++) {
          newHTML +=
            '<td style="text-align: center; font-weight: bold">' +
            ThsTextArry[i] +
            "</td>";
        }
  
        newHTML += "</tr>";
        div
          .querySelector(".el-table__body-wrapper table")
          .insertAdjacentHTML("afterbegin", newHTML);
        // 将新的 DIV 添加到页面 打印后再删掉
        document.querySelector("body").appendChild(div);
        printJS({
          printable: printDOMID,
          type: "html",
          scanStyles: false,
          style:
            "table {  width: 100%; border-collapse: collapse; border-spacing: 0; } table th{ line-height: 20px; padding: 9px 15px; border: 1px solid #ccc; text-align: left; font-size: 12px; color: #666;text-align: right;} table td{line-height: 20px; padding: 9px 15px; border: 1px solid #ccc; text-align: left; font-size: 12px; color: #666;text-align: left;}", // 表格样式
        });
  
        div.remove();
      },
    },
    mounted() {
      var currentDate = new Date();
      if (!this.filters.startTime) {
        // 减去7天
        this.filters.startTime = util.formatDate.format(
          currentDate,
          "yyyy-MM-dd 00:00:00"
        );
      }
      if (!this.filters.endTime) {
        this.filters.endTime = util.formatDate.format(
          currentDate,
          "yyyy-MM-dd 23:59:59"
        );
      }
      this.getReportList();
    },
  };
  </script>
  
  <style lang="less" scoped>
  .input-select {
    width: 300px;
  }
  </style>
  